export default {
  default: () => import("E:/shuzilvtu/gvi-mall/layouts/default.vue").then(m => m.default || m),
  footer: () => import("E:/shuzilvtu/gvi-mall/layouts/footer.vue").then(m => m.default || m),
  header: () => import("E:/shuzilvtu/gvi-mall/layouts/header.vue").then(m => m.default || m)
}